<template>
    <b-media vertical-align="center">
        <avatar :size="60" :src="pdi.user.picture" :username="pdi.user.name" slot="aside" class="d-down-none" />
        <div>
            <p class="mb-0 text-small-sm-down text-justify">
                <strong>{{ action_plan.title }}</strong>
            </p>
            <div class="d-flex justify-content-between">
                <p class="mb-0">
                    <small class="text-muted">{{ pdi.user.name }}</small>
                </p>
            </div>
            <div>
                <progress-bar :value="action_plan.current_value" :height="'10px'" />
            </div>
            <div class="d-flex justify-content-between">
                <p class="mb-0 ml-auto">
                    <span class="text-muted">
                        {{ getStatusProgress }}
                    </span>
                </p>
            </div>
        </div>
    </b-media>
</template>

<script>
import Avatar from 'vue-avatar'
import ProgressBar from '@/views/components/progress-bar/ProgressBar'
import { formatPercentage } from '@/lib/utils'

export default {
    name: 'ActionPlanProgress',
    props: {
        pdi: {
            type: Object,
            required: true,
        },
        action_plan: {
            type: Object,
            required: true,
        },
    },
    components: {
        Avatar,
        ProgressBar,
    },
    methods: {
        formatPercentage(number) {
            if (isNaN(number)) {
                number = 0
            }
            return formatPercentage(number)
        },
    },
    computed: {
        getStatusProgress() {
            return this.action_plan.current_value ? formatPercentage(this.action_plan.current_value, 2) + '%' : '-'
        },
    },
}
</script>

<style lang="sass"></style>
